import { useContext, useEffect, useState } from "react";
import { Card, Container, Row, Col, Button } from "react-bootstrap";
import FeaturedProducts from "./FeaturedProducts";
import UserContext from "../context/UserContext";

function HomeLanding() {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const { user } = useContext(UserContext);

  const fetchProducts = async () => {
    let url =
      user && user.isAdmin
        ? `${process.env.REACT_APP_API_BASE_URL}/products/all`
        : `${process.env.REACT_APP_API_BASE_URL}/products/active`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();

      // get 3 random products
      const randomProducts = data.sort(() => 0.5 - Math.random()).slice(0, 3);
      if (randomProducts.length < 3) {
        setFeaturedProducts([]);
        return;
      }
      setFeaturedProducts(randomProducts);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  return (
    <div className="home-page-wrapper">
      {/* Hero Section */}
      <div className="hero-section">
        <Container>
          <Row className="align-items-center min-vh-100 py-5">
            <Col lg={6} className="text-center text-lg-start">
              <div className="hero-content">
                <h1 className="display-2 fw-bold text-white mb-4">
                  Welcome to
                  <span className="hero-brand-text d-block">FreshMart</span>
                </h1>
                <p className="lead text-white-50 mb-5 pe-lg-5">
                  Discover the freshest and finest products available online.
                  From farm to table, we bring you premium quality groceries
                  with unmatched freshness and taste.
                </p>
                <div className="hero-buttons d-flex flex-column flex-sm-row gap-3">
                  <Button
                    href="/products"
                    variant="outline-light"
                    size="lg"
                    className="px-5 py-3 fw-semibold"
                    style={{
                      borderRadius: "30px",
                      borderWidth: "2px",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <i className="fas fa-leaf me-2"></i>
                    Browse Products
                  </Button>
                </div>
              </div>
            </Col>
            <Col lg={6} className="text-center mt-5 mt-lg-0">
              <div className="hero-visual">
                <div className="hero-icon-container">
                  <i className="fas fa-store"></i>
                </div>
                <div className="floating-cards">
                  <div className="floating-card card-1">
                    <i className="fas fa-leaf"></i>
                    <span>Fresh</span>
                  </div>
                  <div className="floating-card card-2">
                    <i className="fas fa-award"></i>
                    <span>Quality</span>
                  </div>
                  <div className="floating-card card-3">
                    <i className="fas fa-shipping-fast"></i>
                    <span>Fast</span>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Features Section */}
      <section className="features-section py-5">
        <Container>
          <Row className="text-center mb-5">
            <Col>
              <h2 className="display-4 fw-bold text-dark mb-3">
                Why Choose FreshMart?
              </h2>
              <p className="lead text-muted">
                Experience the difference with our premium service
              </p>
            </Col>
          </Row>
          <Row className="g-4">
            <Col md={4}>
              <Card className="feature-card border-0 shadow-lg h-100 text-center">
                <Card.Body className="p-5">
                  <div className="feature-icon mb-4">
                    <i className="fas fa-leaf"></i>
                  </div>
                  <h4 className="fw-bold mb-3">Premium Fresh</h4>
                  <p className="text-muted">
                    Handpicked fresh products delivered straight from farms to
                    your doorstep
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="feature-card border-0 shadow-lg h-100 text-center">
                <Card.Body className="p-5">
                  <div className="feature-icon mb-4">
                    <i className="fas fa-shipping-fast"></i>
                  </div>
                  <h4 className="fw-bold mb-3">Fast Delivery</h4>
                  <p className="text-muted">
                    Same-day delivery available. Get your groceries when you
                    need them
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="feature-card border-0 shadow-lg h-100 text-center">
                <Card.Body className="p-5">
                  <div className="feature-icon mb-4">
                    <i className="fas fa-award"></i>
                  </div>
                  <h4 className="fw-bold mb-3">Quality Assured</h4>
                  <p className="text-muted">
                    100% quality guarantee. Not satisfied? We'll make it right
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Featured Products Section */}
      <section className="featured-section py-5">
        <Container>
          <Row className="text-center mb-5">
            <Col>
              <h2 className="display-4 fw-bold text-dark mb-3">
                Featured Products
              </h2>
              <p className="lead text-muted mb-4">
                Discover our most popular and freshest items
              </p>
              <div className="section-divider mx-auto"></div>
            </Col>
          </Row>
          {featuredProducts.length === 0 ? null : (
            <FeaturedProducts products={featuredProducts} />
          )}
          <Row className="text-center mt-5">
            <Col>
              <Button
                href="/products"
                size="lg"
                className="px-5 py-3 fw-bold"
                style={{
                  borderRadius: "25px",
                  background:
                    "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
                  border: "none",
                  boxShadow: "0 8px 25px rgba(40, 167, 69, 0.3)",
                }}
              >
                <i className="fas fa-arrow-right me-2"></i>
                View All Products
              </Button>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Enhanced Custom Styles */}
      <style jsx>{`
        .home-page-wrapper {
          overflow-x: hidden;
        }

        .hero-section {
          background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
          position: relative;
          overflow: hidden;
        }

        .hero-section::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="heroPattern" width="30" height="30" patternUnits="userSpaceOnUse"><circle cx="15" cy="15" r="1.5" fill="white" opacity="0.1"/><circle cx="5" cy="25" r="0.8" fill="white" opacity="0.15"/><circle cx="25" cy="5" r="0.8" fill="white" opacity="0.15"/></pattern></defs><rect width="100" height="100" fill="url(%23heroPattern)"/></svg>');
          pointer-events: none;
        }

        .hero-brand-text {
          background: linear-gradient(45deg, #ffffff, #f8f9fa);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          text-shadow: 0 0 30px rgba(255, 255, 255, 0.5);
        }

        .hero-btn-primary:hover {
          transform: translateY(-3px) scale(1.05);
          box-shadow: 0 12px 35px rgba(255, 255, 255, 0.4) !important;
          color: #20c997 !important;
        }

        .btn-outline-light:hover {
          background: white !important;
          color: #28a745 !important;
          border-color: white !important;
          transform: translateY(-3px);
          box-shadow: 0 8px 25px rgba(255, 255, 255, 0.3);
        }

        .hero-visual {
          position: relative;
          height: 400px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .hero-icon-container {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          width: 200px;
          height: 200px;
          display: flex;
          align-items: center;
          justify-content: center;
          backdrop-filter: blur(20px);
          box-shadow: 0 20px 60px rgba(255, 255, 255, 0.2);
        }

        .hero-icon-container i {
          font-size: 5rem;
          color: white;
        }

        .floating-cards {
          position: absolute;
          width: 100%;
          height: 100%;
        }

        .floating-card {
          position: absolute;
          background: rgba(255, 255, 255, 0.9);
          border-radius: 15px;
          padding: 15px 20px;
          display: flex;
          align-items: center;
          gap: 10px;
          font-weight: 600;
          color: #28a745;
          box-shadow: 0 10px 30px rgba(255, 255, 255, 0.3);
          animation: float 6s ease-in-out infinite;
          backdrop-filter: blur(10px);
        }

        .floating-card i {
          font-size: 1.2rem;
        }

        .card-1 {
          top: 20%;
          right: 10%;
          animation-delay: 0s;
        }

        .card-2 {
          bottom: 30%;
          left: 5%;
          animation-delay: 2s;
        }

        .card-3 {
          top: 60%;
          right: 20%;
          animation-delay: 4s;
        }

        @keyframes float {
          0%,
          100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }

        .features-section {
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        }

        .feature-card {
          border-radius: 20px !important;
          transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
        }

        .feature-card:hover {
          transform: translateY(-10px) scale(1.02);
          box-shadow: 0 20px 40px rgba(40, 167, 69, 0.15) !important;
        }

        .feature-icon {
          background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
          width: 80px;
          height: 80px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
        }

        .feature-icon i {
          font-size: 2rem;
          color: white;
        }

        .featured-section {
          background: white;
        }

        .section-divider {
          width: 100px;
          height: 4px;
          background: linear-gradient(90deg, transparent, #28a745, transparent);
          border-radius: 2px;
        }

        @media (max-width: 768px) {
          .hero-section .display-2 {
            font-size: 2.5rem;
          }

          .hero-icon-container {
            width: 150px;
            height: 150px;
          }

          .hero-icon-container i {
            font-size: 3.5rem;
          }

          .floating-card {
            padding: 10px 15px;
            font-size: 0.9rem;
          }

          .hero-visual {
            height: 300px;
          }
        }
      `}</style>
    </div>
  );
}

export default HomeLanding;
